import React from 'react';
import styled from 'styled-components';

const MessageText = ({ message }: { message: string }) => {

  const paragraphs = message.split(/\s*\n\s*/);

  return <>
    {paragraphs.map((paragraph, index) => <Paragraph key={index}>{paragraph}</Paragraph>)}
  </>;
}

const Paragraph = styled.div`
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export default MessageText;
